import AccountUser from "./account-user.page";

export default AccountUser;
